import CountUp from "countup.js";

export default {
    init() {
      var fieldSelector = "#field_5_10";
      if (window.location.href.indexOf("rocasalvatella.test") > -1 || window.location.href.indexOf("localhost") > -1) {
        fieldSelector = "#field_3_10";
      }

        function sizeError() {
            if($(fieldSelector + " .validation_message").text().length > 0) {
                $(fieldSelector).append($(fieldSelector + " .validation_message").clone());
            }
        }
        sizeError();
    },
    finalize() {
      var fieldSelector = "#field_5";
      var subfieldAttachmentSelector = fieldSelector + "_32";
      var subfieldRealAttachmentSelector = fieldSelector + "_31";
      var inputSelector = "#input_5_32";
      var inputSelectorOr = "#input_5_31";
      if (window.location.href.indexOf("rocasalvatella.test") > -1 || window.location.href.indexOf("localhost") > -1) {
        fieldSelector = "#field_3";
        inputSelector = "#input_3_21";
        inputSelectorOr = "#input_3_10";
        subfieldAttachmentSelector = fieldSelector + "_21";
        subfieldRealAttachmentSelector = fieldSelector + "_10";
      }

        // Load Counters
        var canStart = true;
        function loadCounters() {
            if($('.counters').visible() && canStart) {
                new CountUp("count1", 0, $("#count1").data("val"), 0, 3).start();
                new CountUp("count2", 0, $("#count2").data("val"), 0, 3).start();
                new CountUp("count3", 0, $("#count3").data("val"), 0, 3).start();
                new CountUp("count4", 0, $("#count4").data("val"), 0, 3).start();
                canStart = false;
            }
        }
        setTimeout(function() {
            loadCounters();
        }, 700);
        $(window).scroll(function() {
            loadCounters();
        });

        $('.collapse').on('shown.bs.collapse', function () {
            $(this).find("iframe").attr("src", $(this).closest(".section-wrapper").data("map-url"));
            $(".bg-wrapper").css("background-image", "url('"+$(this).closest(".section-wrapper").data("image-url")+"')");
            $(".section-map-desktop iframe").attr("src", $(this).closest(".section-wrapper").data("map-url"));
            var hover_src = $(this).parent().find('.collapse-icon').data('hover-src');
            $(this).parent().find('.collapse-icon').attr("src", hover_src);
            $('.section-button').removeClass("shown");
            $(this).parent().find('.section-button').addClass("shown");
            $(".section-team").show();
        });
        $('.collapse').on('hidden.bs.collapse', function () {
            var src = $(this).parent().find('.collapse-icon').data('src');
            $(this).parent().find('.collapse-icon').attr("src", src);
        });
        $('.section-button').on("click", function() {
            $(".collapse").collapse("hide");
        });
        $('.section-button').first().trigger("click").addClass("shown");


        $(".gform_body input[value!=''], input[type='checkbox'], .gform_body textarea:not(:empty)").closest(".gfield").find(".gfield_label").addClass("d-block").removeClass("d-none");

        if($(".ginput_preview").length > 0) {
            generateIconsFile();
            $(inputSelector).addClass("pFile");
            $(subfieldAttachmentSelector).append($(subfieldRealAttachmentSelector + " .validation_message").clone());
        }else {
            $(subfieldAttachmentSelector).append($(subfieldRealAttachmentSelector + " .validation_message").clone());
        }

        $(".file-fake input").prop('readonly', true);

        $(".ginput_container input, textarea").on("keyup", function() {
            if ($(this).val().length > 0) {
                $(this).closest(".gfield").find(".gfield_label").addClass("d-block").removeClass("d-none");
            } else {
                $(this).closest(".gfield").find(".gfield_label").removeClass("d-block").addClass("d-none");
            }
        });

        $(inputSelector).on( "click", function() {
            $(inputSelectorOr).trigger( "click" );
        });

        $(inputSelectorOr).on("change", function () {
            var nameFile = $(inputSelectorOr).get()[0].files[0].name;
            if (nameFile.length > 40) {
                if($( window ).width() > 1440) {
                    nameFile =nameFile.substr(0, 40) + "...";
                }else {
                    nameFile = nameFile.substr(0, 25) + "...";
                }
            }
            $(inputSelector).val(nameFile);
            generateIconsFile();
            $(inputSelector).addClass("pFile");
            $(".document-icon").addClass('d-block').removeClass('d-none');
            $(".iconRemove").addClass('d-block').removeClass('d-none');
            $(subfieldAttachmentSelector).closest(".gfield").find(".gfield_label").addClass("d-block").removeClass("d-none");
            $(subfieldAttachmentSelector + " validation_message").text('');
        });

        setTimeout(function() {
            $(inputSelectorOr).attr("onchange", $(inputSelectorOr).attr("onchange") + '(jQuery("' + inputSelectorOr + ' .validation_message").text().length > 0) ? jQuery("' + inputSelector + ' .validation_message").text(jQuery("' + inputSelectorOr + ' .validation_message").text()) :  ""');
        }, 3000);

            function generateIconsFile() {
                $("<span>").addClass('document-icon').insertBefore($('.file-fake input'));
            $("<span>").addClass('iconRemove').insertBefore($('.file-fake input'));

            $('.iconRemove').on("click", function () {
                $(inputSelector).val("");
                $(".document-icon").remove();
                $(".iconRemove").remove();
                $(inputSelectorOr).val("");
                $("div[id^='gform_preview']").remove();
                $("input[name='gform_uploaded_files']").remove();
                $(inputSelector).removeClass("pFile");
            });
        }
        //
        // // $("#contact_modal_error").modal();
        //
        if($("div[id='gform_confirmation_message_3']").length > 0 | $("div[id='gform_confirmation_message_2']").length > 0 ){
            $("#contact_modal").modal();
        }
        $("#contact_modal").on('hide.bs.modal', function(){
            window.location.href = window.location.href;
        });
    },
};







// WEBPACK FOOTER //
// ./scripts/routes/contact.js